import React from 'react';
import Header from '../layout/header/main/HeaderContainer';
import Footer from '../layout/footer/FooterContainer';

const Layout = (props) => {
	return (
		<>
			<Header />
			<main className="content">
				{props.children}
			</main>
			<Footer />
		</>
	);
};

export default Layout;
